const isProduction = process.env.NODE_ENV === 'production'
//  const proUrl = 'http://emergencyai.web.shuzhiren.com'
//  const proUrl = 'http://test.ever.ai.guanyingis.com'
let proUrl = ''
if (location.href.includes('localhost')) {
    proUrl = 'https://strawberryai.web.shuzhiren.com'//
}
export const baseUrl = proUrl

// 文件上传地址
export const uploadUrl = `${isProduction ? baseUrl : ''}/gptapi/app/oss/file`
